<template>
<v-container>
   
    <div id="chart">
        <apexchart type="bar" height="200" :options="chartOptions" :series="series"></apexchart>
    </div>
</v-container>
</template>

<script>
import {
    defineComponent
} from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts';
import apifactory from '../../api';
export default defineComponent({
    setup() {

    },
    components: {

        apexchart: VueApexCharts,

    },

    data: () => ({
        Item_roi_activity: [],
        Item_roi_activity12: [],
        Item_Category:[],
        series: [],
        chartOptions: {
            chart: {
                type: 'bar',
                height: 350
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '25%',
                    endingShape: 'rounded'
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },

            yaxis: {
                title: {
                    text: 'ROI'
                }
            },
            fill: {
                opacity: 1
            },

            tooltip: {
                y: {
                    formatter: function (val) {
                        return "" + val + ""
                    }
                }
            }
        },

    }),
    methods: {
        getroi_activity() {
            apifactory.get_model_roi_activity()
                .then((res) => {
                    // alert(res.id);

                    if (res.status != 200) {
                        //this.countryList = null;
                        alert(res.message);

                    } else {
                        this.Item_roi_activity = [];
                        let tempdata1 = res.data;
                        for (var i = 0; i < tempdata1.length; i++) {
                            if (tempdata1[i].variable != "base") {
                            this.Item_roi_activity.push(tempdata1[i].spend);}
                        }
                        this.getroi_activity12();

                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        getroi_activity12() {
            apifactory.get_model_roi_activity12()
                .then((res) => {
                    // alert(res.id);

                    if (res.status != 200) {
                        //this.countryList = null;
                        alert(res.message);

                    } else {
                        this.Item_roi_activity12 = [];
                         this.Item_Category=[];
                        let tempdata1 = res.data;
                        for (var i = 0; i < tempdata1.length; i++) {
                            if (tempdata1[i].variable != "base") {
                            this.Item_roi_activity12.push(tempdata1[i].spend);
                            this.Item_Category.push(tempdata1[i].variable)}
                        }
                        this.binddata();
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        binddata() {
            
            this.series = [{
                "name": "spend1",
                "data":  this.Item_roi_activity
            }, {
                "name": "spend2",
                "data":  this.Item_roi_activity12
            }];
            this.chartOptions = {

                xaxis: {
                    categories: this.Item_Category,
                },
            }

        }
    },
    mounted() {
        this.getroi_activity();
       // this.binddata();

    },
})
</script>
